export interface CloseReasonOption {
  label: string;
  value: string;
}

export const CLOSE_REASONS: CloseReasonOption[] = [
  { label: 'External hire', value: 'external_hire' },
  { label: 'Internal transfer', value: 'internal_transfer' },
  { label: 'Internal promotion', value: 'internal_promotion' },
  { label: 'Budget cuts', value: 'budget_cuts' },
  { label: 'Hiring freeze', value: 'hiring_freeze' },
  { label: 'On hold', value: 'on_hold' },
  { label: 'Role no longer needed', value: 'role_no_longer_needed' },
  { label: 'Created by mistake', value: 'created_by_mistake' },
  { label: 'Others', value: 'others' },
];

export interface CloseRequisitionPayload {
  rejection_reason: string;
  rejection_reason_description?: string; // Required only when rejection_reason is 'others'
}
